import React from "react";
import "./cardCarousel.scss";
import { Carousel } from "primereact/carousel";

const cardItems = [
  {
    id: 1,
    title: "Verified Organizational Spaces",
    copy:
      "Unlike other anonymous apps, Orter allows verified organizations like schools, churches, or support groups to create private spaces for members. Each organization can add representatives (like mentors, pastors, experts, or counselors) who users can chat with anonymously."
  },
  {
    id: 2,
    title: "Topic-Based Matching",
    copy: "Users can find and chat with others who share specific interests or experiences. Filter by topic, location, age range, and even gender to connect with the right person for your conversation."
  },
  {
    id: 3,
    title: "Reputation Through Ratings",
    copy: "Every conversation helps build a user’s topic rating, showing how knowledgeable or supportive they are in certain areas, making it easier to find trusted peers."
  },
  {
    id: 4,
    title: "Private Organizational Feeds",
    copy:
      "Each organization has a private feed where members can post, ask questions, or share thoughts only visible within that community."
  },
  {
    id: 5,
    title: "Respectful, Safe Conversations",
    copy: "Orter actively monitors for bullying, hate speech, or trolling. Your privacy and safety come first."
  }
];

const CardCarousel = () => {
  const cardTemplate = (item) => {
    return (
      <div className="card-item">
        <h2>{item.title}</h2>
        <p>{item.copy}</p>
      </div>
    );
  };

  return (
    <div className="perks">
      <div className="left">
        <div className="card">
          <Carousel
            value={cardItems}
            numVisible={1}
            numScroll={1}
            orientation="vertical"
            style={{ height: '100%' }}
            itemTemplate={cardTemplate}
            circular
            autoplayInterval={5500}
          />
        </div>
      </div>
      <div className="right">
        <h1>
          How <span>Orter</span> is Different from Other Anonymous Platforms
        </h1>
      </div>
    </div>
  );
};

export default CardCarousel;
